import { ServiceRequest } from 'src/app/models/service-request';

export interface ServiceRequestState {
  serviceRequests: ServiceRequest[];
  fetchedAt: Date | null;
}

export const initialServiceRequestState: ServiceRequestState = {
  serviceRequests: [],
  fetchedAt: null,
};
